module.exports = __webpack_public_path__ + "static/media/17_l_vetka_5.31_60.19.0757450b.png";